"use client";
import Image from "next/image";

const detailsData = [
    { title: "Segment", info: "Startup", },
    { title: "Platform", info: "Web Application", },
    { title: "Geography", info: "Los Angeles, USA", },
    { title: "Audience", info: "New and growing creators across genres", },
    { title: "Services", info: "Strategy and ideation, digital product experiences, technology planning, growth systems", },
    { title: "Primary outcomes", info: "Faster activation, first earnings, subscriber retention, creator trust", },
];

const PortfolioInfo = () => {
    return (
        <div
            id="desilo-portfolio-details-section"
            className="desilo-portfolio-details-section section-padding-top"
        >
            <div className="container custom-container">
                <div className="row g-4 justify-content-between">
                    <div className="quate-details-box">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" viewBox="0 0 42 34" fill="none">
                                <g clipPath="url(#clip0_3257_80348)">
                                    <mask id="mask0_3257_80348" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="34">
                                        <path d="M42 33.5312L0 33.5312L0 0.53125L42 0.53125L42 33.5312Z" fill="white" />
                                    </mask>
                                    <g mask="url(#mask0_3257_80348)">
                                        <path d="M3.78651 3.40053C1.42857 6.03544 0.0138359 8.90987 0.0138359 13.7006C0.0138359 22.0844 5.9086 29.5101 14.1612 33.3426L16.2833 30.2287C8.50227 25.917 6.85173 20.4077 6.38019 16.8146C7.55913 17.5332 9.20961 17.7728 10.8602 17.5332C15.1044 17.0541 18.4055 13.7006 18.4055 9.14943C18.4055 6.99361 17.4623 4.83775 16.0475 3.161C14.397 1.48424 12.5107 0.765627 10.1528 0.765627C7.55913 0.765627 5.20119 1.96331 3.78651 3.40053ZM27.3654 3.40053C25.0076 6.03543 23.5928 8.90987 23.5928 13.7006C23.5928 22.0844 29.4875 29.5101 37.7402 33.3426L39.8623 30.2287C32.0812 25.917 30.4307 20.4076 29.9591 16.8146C31.1381 17.5332 32.7886 17.7728 34.4391 17.5332C38.6833 17.0541 41.9844 13.7006 41.9844 9.14943C41.9844 6.99361 41.0412 4.83775 39.6265 3.16099C38.2117 1.48424 36.0896 0.765624 33.7317 0.765625C31.1381 0.765625 28.7802 1.9633 27.3654 3.40053Z" fill="#E25926" />
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="clip0_3257_80348">
                                        <rect width="42" height="33" fill="white" transform="matrix(-1 0 0 1 42 0.53125)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div>
                            <div className="text">
                                &ldquo;It is easy to start and the experience feels great. If you have a niche, you can be a creator on Cabotto&rdquo;
                            </div>
                            <div>- Beth Wright</div>
                        </div>
                    </div>
                </div>

                {/* Project overview */}
                <div className="row g-4 justify-content-between section-padding-top ">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            Project <br />
                            overview
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <h3>A platform that helps new creators in any genre start fast, livestream confidently, and turn fans into paying supporters.</h3>
                            <p className="portfolio-text">
                                Cabotto is a web application built for the creator economy. It gives first time and growing creators a simple path from posting to perks to payouts, all in one place. By pairing research driven design with reliable engineering, Cabotto delivers clarity for creators, transparent value for fans, and a foundation that scales.
                            </p>
                        </div>

                        {/* ✅ Dynamic Info Section with framer-motion */}
                        <div className="portfolio-details__info row-padding-top">
                            {detailsData.map((item, i) => (
                                <div key={i} className="portfolio-details-box">
                                    <span className="title">{item.title}</span>
                                    <h6 className="info">{item.info}</h6>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* ✅ Images Section */}
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/cabotto/portfolio-details-2.png"
                            alt="Cabotto creator earnings dashboard displaying subscribers, payouts, referrals, engagement metrics, and revenue growth chart for creators"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>

                {/* The Challenges */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            The <br />
                            Challenges
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <div className="portfolio-text">
                                <div className="border-bottom-text">
                                    <p>
                                        Unclear first steps for new creators
                                    </p>
                                    <p>
                                        Tooling felt overwhelming. Getting from first post to a simple offer was not obvious.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Inconsistent engagement cadence
                                    </p>
                                    <p>
                                        Without a basic rhythm and prompts, posting stalled and momentum faded.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Fragmented monetization
                                    </p>
                                    <p>
                                        Perks, paywalls, and subscriber messaging lived in different tools. Fans could not see the value easily.
                                    </p>
                                </div>
                                <div className="border-bottom-text">
                                    <p>
                                        Hard to present a credible, single home
                                    </p>
                                    <p>
                                        Creators needed one place that explained what supporters get and why to join, with progress they could show.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* What we found */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            What <br />
                            we found
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                New creators want a clear starting lane, not a wall of features. They trust flows that explain value in plain language, keep creation and monetization together, and make next steps obvious. Fans respond to clarity on perks, access, and updates more than to one off hype.
                            </p>
                        </div>
                    </div>
                </div>

                {/* The Solution */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            The <br />
                            Solution
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                We designed a focused product that guides creators from setup to first earnings. The core includes a posting system, a clean subscriber hub, and a community space that keeps supporters engaged. The app highlights the next best action, bundles perks and messaging, and shows progress with simple dashboards both creators and fans understand.
                            </p>
                        </div>
                    </div>
                </div>

                {/* ✅ Images Section */}
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/cabotto/portfolio-details-3.png"
                            alt="Cabotto creator profile page showing user details, followers, posts, and messaging sidebar for community engagement and networking"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/cabotto/portfolio-details-4.png"
                            alt="Cabotto messaging interface showing chat conversations, media sharing, and real-time private messages between creators and fans"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>
                <div className="row g-3 g-lg-4 section-padding-top">
                    <div className="col-12 overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src="/images/portfolio-details/cabotto/portfolio-details-5.png"
                            alt="Cabotto subscription plans dashboard where creators set monthly pricing, offer discounts, and run promotional campaigns for fans"
                            data-speed="0.8"
                            className="w-100 h-100"
                        />
                    </div>
                </div>

                {/* Key Services */}
                <div>
                    <div className="row g-4 justify-content-between section-padding-top">
                        <div className="">
                            <h2 className="portfolio-details__title">
                                Key Services
                            </h2>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Strategy  & Ideation
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                We started with a fast product ideation sprint, then talked to real users to hear jobs to be done in their own words. From there, we mapped a simple offer that a new creator could understand in seconds. Together we defined the ICP segments, sharpened the value proposition, and set a test plan where activation and paid conversion were the first goals.
                            </p>
                            <div className="row justify-content-between pt-4">
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb.png"
                                                alt="Cabotto strategy and ideation process with UX wireframe sketches on a whiteboard for product design planning"
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb-1.png"
                                                alt='Cabotto ideation session showing website creation flowchart with design, database, and CMS planning steps'
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="desilo-project-box overflow-hidden">
                                        <div className="desilo-project-thumb overflow-hidden">
                                            <Image
                                                height={500}
                                                width={500}
                                                sizes="100vw"
                                                src="/images/portfolio-details/cabotto/blog-thumb-2.png"
                                                alt='Cabotto product team collaborating on coding and development, reviewing software interface and discussing technical solutions'
                                                className="w-100 h-100 img_reveal"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/cabotto/julia.jpg"
                                    alt="Cabotto strategy service using user persona profile for Julia, outlining goals, frustrations, and lifestyle insights for design decisions"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Digital product experiences
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                With direction locked, we shaped the product from the ground up. We organized the sitemap, drew user flows, and explored wireframes before moving into visual design and a reusable design system. We prototyped the posting OS, the subscriber hub, and the paywall journeys, then put them in front of real creators to refine before build.
                            </p>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/cabotto/portfolio-details-6.png"
                                    alt="Cabotto digital product experience wireframe showing early interface layout with placeholders for posts, notifications, and navigation"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/cabotto/portfolio-details-7.png"
                                    alt="Cabotto digital product experience showcasing final dark mode interface with posts, messaging sidebar, and community engagement features"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Technology & Transformation
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                Once the experience felt right, we planned a SaaS ready architecture for the web app. Payments, messaging, and analytics all hook in cleanly, with room for AI helpers like caption suggestions and support summaries. We added CI and CD guidance so releases stay calm and frequent as the team grows.
                            </p>
                            <div className="row-padding-top overflow-hidden">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src="/images/portfolio-details/cabotto/portfolio-details-8.png"
                                    alt="Cabotto digital product experience showcasing final dark mode interface with posts, messaging sidebar, and community engagement features"
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-between row-padding-top">
                        <div className="col-lg-4">
                            <h3 className="portfolio-details__title position-sticky sticky-col">
                                Go to market and growth systems
                            </h3>
                        </div>
                        <div className="col-lg-6">
                            <p className="portfolio-text">
                                Finally, we wired the growth loop. Onboarding checklists and lifecycle messages help new creators reach first value quickly, while pricing templates, trials, and referrals make conversion simple to test. Cohort dashboards track activation, paid conversion, and retention so the team learns every week and scales what works.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Outcomes */}
                <div className="row g-4 justify-content-between section-padding-top">
                    <div className="col-lg-4">
                        <h2 className="portfolio-details__title position-sticky sticky-col">
                            Outcomes
                        </h2>
                    </div>
                    <div className="col-lg-6">
                        <div className="portfolio-details__content">
                            <p className="portfolio-text">
                                Cabotto launched a creator friendly platform that removes guesswork and builds trust. First time creators can start quickly, present a clear offer, and keep engagement steady through simple routines and updates. Leadership can see progress in dashboards that track activation, conversion, and retention across cohorts.
                            </p>
                            <div className="row-padding-top border-bottom-text border-0 pb-0">
                                <p>Highlights</p>
                                <ul>
                                    <li><span>Built a custom livestream module in 2 weeks and integrated with OBS for production ready streams.</span></li>
                                    <li><span>Shipped the core monetization flow in 1 week, including perks, tiers, and a clean paywall.</span></li>
                                    <li><span>Implemented Persona for user verification, Stripe for payments and payouts, and AWS for hosting and storage.</span></li>
                                    <li><span>User feedback: easy to start, creators love the experience, and anyone with a niche can become a creator and earn.</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortfolioInfo;
